<template>
  <div
    class="audio-player w-100 justify-content-end d-flex"
    :class="wrapperClass"
    :style="{ width: width }"
  >
    <div class="controls mt-3 d-flex align-items-center">
      <div class="col-8"><div ref="waveform" class="wavef"></div></div>
      <div
        class="col-2"
        style="font-size: 10px"
        :style="{ color: option.waveColor }"
      >
        {{ formattedDuration }}
      </div>
      <div class="col-2 text-center">
        <i
          v-if="isPlaying == true"
          class="bx align-middle font-size-24 play-icon cursor-pointer mx-2 bx-pause-circle"
          @click="playPause"
          :style="{ '--pseudo-color3': colors.iconcolor }"
        ></i>
        <iconsvg
          v-else
          name="audio"
          :color="colors.iconcolor"
          @click="playPause"
        ></iconsvg>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted, computed, onBeforeUnmount } from "vue";
import WaveSurfer from "wavesurfer.js";
import iconsvg from "./iconsvg.vue";
export default {
  name: "AudioPlayer",
  components: { iconsvg },
  props: {
    colors: {
      type: Object,
      required: true,
    },
    option: Object,
    wrapperClass: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
  },
  setup(props) {
    const waveform = ref(null);
    const isPlaying = ref(false);
    const waveSurfer = ref(null);
    const volume = ref(50);
    const currentTime = ref(0);
    const totalDuration = ref(0);
    onMounted(() => {
      initAudioPlayer();
    });
    const initAudioPlayer = () => {
      if (!waveSurfer.value) {
        try {
          waveSurfer.value = WaveSurfer.create({
            container: waveform.value,
            ...props.option,
          });
          waveSurfer.value.on("play", () => (isPlaying.value = true));
          waveSurfer.value.on("pause", () => (isPlaying.value = false));
          // Set duration when the audio is ready
          waveSurfer.value.on("decode", (percent) => {
            console.log("decode", percent);
          });
          // redraw
          waveSurfer.value.on("redraw", () => {
            // console.log('redraw', );
          });
          waveSurfer.value.on("ready", () => {
            // console.log('ready');
            totalDuration.value = waveSurfer.value.getDuration();
          });
          // Update current time as the audio plays
          waveSurfer.value.on("audioprocess", (time) => {
            currentTime.value = time;
          });
          // // // Rewind to the beginning on finished playing
          waveSurfer.value.on("finish", () => {
            currentTime.value = 0;
            waveSurfer.value.setTime(0);
            waveSurfer.value.setPlaybackRate(1);
          });
          waveSurfer.value.on("interaction", (val) => {
            waveSurfer.value.setTime(val);
            waveSurfer.value.play();
          });
          waveSurfer.value.on("init", () => {
            // console.log('init');
          });
          waveSurfer.value.on("click", (val) => {
            console.log("click", val);
          });
          waveSurfer.value.on("destroy", () => {
            // console.log('destroy');
          });
          waveSurfer.value.on("error", (error) => {
            console.log("error", error);
          });
          waveSurfer.value.on("load", () => {
            totalDuration.value = waveSurfer.value.getDuration();
          });
          waveSurfer.value.on("loading", (percent) => {
            console.log("loading", percent);
          });
          waveSurfer.value.on("pause", () => {
            // console.log('pause');
          });
          waveSurfer.value.on("play", () => {
            // console.log('play');
          });
          waveSurfer.value.on("seeking", (time) => {
            console.log("seeking", time);
          });
        } catch (error) {
          console.error("Error initializing WaveSurfer:", error);
        }
      }
    };
    // Clean up WaveSurfer on component unmount
    onBeforeUnmount(() => {
      if (waveSurfer.value) {
        waveSurfer.value.destroy();
      }
    });
    onUnmounted(() => {
      if (waveSurfer.value) waveSurfer.value.destroy();
    });
    // Computed properties to format time in MM:SS
    const formatTime = (seconds) => {
      const minutes = Math.floor(seconds / 60)
        .toString()
        .padStart(2, "0");
      const secs = Math.floor(seconds % 60)
        .toString()
        .padStart(2, "0");
      return `${minutes}:${secs}`;
    };
    const formattedCurrentTime = computed(() => formatTime(currentTime.value));
    const formattedDuration = computed(() => formatTime(totalDuration.value));
    // Control functions
    const playPause = () => {
      waveSurfer.value.playPause();
      isPlaying.value = waveSurfer.value.isPlaying();
      totalDuration.value = waveSurfer.value.getDuration();
    };

    const stop = () => {
      waveSurfer.value.stop();
      currentTime.value = 0;
      isPlaying.value = false;
    };

    const rewind = () => {
      waveSurfer.value.setPlaybackRate(0.5); // Adjust the time as needed
      waveSurfer.value.play();
    };

    const fastForward = () => {
      waveSurfer.value.setPlaybackRate(2); // Adjust the time as needed
      waveSurfer.value.play();
    };
    const changeVolume = () => {
      waveSurfer.value.setVolume(volume.value / 100);
    };

    // listening question
    const listenQuestion = (time) => {
      if (waveSurfer.value) {
        waveSurfer.value.setTime(time);
        waveSurfer.value.play();
      }
    };
    return {
      volume,
      currentTime,
      totalDuration,
      waveform,
      isPlaying,
      formattedCurrentTime,
      formattedDuration,
      changeVolume,
      playPause,
      stop,
      rewind,
      fastForward,
      listenQuestion,
    };
  },
};
</script>
<style scoped>
.bx-pause-circle:after {
  color: var(--pseudo-color3);
}
.bx-pause-circle:before {
  color: var(--pseudo-color3);
}
</style>
